import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Button,
  PageTitleAndSubTitle,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React, { useEffect, useState } from 'react';
import {
  addScenarios,
  fetchBuildScenario,
  fetchScenarios,
  saveBuildScenario,
  updateBuildScenario,
} from '../../core-utils/axios/financials/scenarios';
import { useStores } from '../../stores';
import useSnackbar from '../../core-utils/custom-hooks/Snackbar';
import Snackbar from '../../_components/atoms/Snackbar';
import AddBuildScenarioModal from '../../_components/organisms/AddBuildScenarioModal';
import BuildScenarioModal from '../../_components/organisms/BuildScenarioModal';
import Financials from '../../_components/organisms/FinancialsTab';
import {
  calculateContributions,
  calculateFee,
  calculateVariableContributions,
  EmployeeCountDataType,
  getFixedCostColumns,
  getVariableCostColumns,
  unitToRowTitleMap,
  UnitType,
} from '../../core-utils/helper-utils/financialForensicsHelper';
import {
  BuildScenario,
  getRowType,
  normalizeFeeCalculation,
  resetFeesToZero,
  resetVariableCostValuesToZero,
} from '../../core-utils/helper-utils/buildScenarioHelper';
import Loader from '../../_components/molecules/Loader';
import AutocompleteWithCheckBoxes from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Autocomplete';
import { getFinancialForensicsData } from '../../core-utils/axios/financials/financial';
import {
  BuildScenarioRowResult,
  RowType,
  TableType,
} from '../FinancialForensicsPage/FinancialForensics.types';
import { useLocation } from 'react-router-dom';
import CustomDateSelectionDropdown, {
  DateType,
} from '../../_components/molecules/CustomDateSelectionDropdown';
import { getAvailableDates as getAvailableDatesAPI } from '../../core-utils/axios/financials/financial';
import moment from 'moment';
import {
  Detail,
  getEmptyVariableCost,
  VariableCost,
} from '../FinancialForensicsPage/types/VariableCost.types';
import {
  FixedCost,
  FixedCostFeeCalculation,
  getEmptyFixedCost,
} from '../FinancialForensicsPage/types/FixedCost.types';
import { TimeSeriesEntry } from '../FinancialForensicsPage/types/EmployeeCount.types';
import { getCalculationVariables } from '../../core-utils/helper-utils/financialForensics/fixedCostHelper';

const useStyles = makeStyles()({
  header: {
    width: '1276px',
    padding: '40px 0px 24px 63px',
  },
  divider: {
    borderBottom: '1px solid ' + patientAccessTheme.palette.grey[300],
  },
  body: {
    width: '1276px',
    padding: '20px 0px 66px 63px',
  },
  titleFlex: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  chip: {
    background: patientAccessTheme.palette.chips.multiChipBackground,
    borderRadius: '4px',
    border:
      '0.5px solid ' + patientAccessTheme.palette.chips.autoCompleteComponent,
    padding: '5px 10px',
    height: '22px',
    '&:active': {
      background: patientAccessTheme.palette.chips.multiChipBackground,
    },
  },
  chipLabel: {
    padding: 0,
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '100%',
    color: patientAccessTheme.palette.chips.autoCompleteComponent,
    // maxWidth: '60px',
    // width: 'fit-content',
    // textOverflow: 'ellipsis',
    // overflow: 'hidden',
    // whiteSpace: 'nowrap',
  },
  deleteIcon: {
    margin: '0px',
    cursor: 'pointer',
    width: '16px',
    height: '16px',
  },
  closeIcon: {
    color: patientAccessTheme.palette.chips.autoCompleteComponent,
  },
  addScenarioButton: {
    padding: '5px 10px',
    border:
      '0.5px dashed ' + patientAccessTheme.palette.chips.autoCompleteComponent,
    background: patientAccessTheme.palette.grey[300],
    '&:hover': {
      background: patientAccessTheme.palette.grey[300],
      border:
        '0.5px dashed ' +
        patientAccessTheme.palette.chips.autoCompleteComponent,
    },
  },
  scenariosGrid: {
    display: 'flex',
    gap: '8px',
  },
});

const BuildScenarioWorkspacePage = () => {
  //Constants
  const { classes } = useStyles();
  const location: any = useLocation();
  const employerGroupStore = useStores().employerGroupStore;
  const loginStore = useStores().loginPageStore;
  const fiscalControlStore = useStores().fiscalControlStore;
  const { startDate, endDate } = fiscalControlStore;
  const egNid = employerGroupStore.employerGroupResponseData.eg_nid[0];
  const email = loginStore?.email;
  const { snackbarState, handleCloseSnackBar, openSnackbar } = useSnackbar();
  const [avaiableDates, setAvaiableDates] = useState<DateType[]>([]);
  const [selectedDates, setSelectedDates] = useState<DateType>({
    startDate: startDate,
    endDate: endDate,
  });

  //UseStates
  const [loading, setLoading] = useState<boolean>(true);
  const [scenarios, setScenarios] = useState<
    {
      id: string;
      name: string;
      notes?: string;
    }[]
  >([]);
  const [selectedScenarios, setSelectedScenarios] = useState<
    {
      id: string;
      name: string;
      notes?: string;
    }[]
  >([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [scenarioInfo, setScenarioInfo] = useState<{
    name: string;
    notes?: string;
  }>({
    name: '',
  });

  //Build Scenario Modal States
  const [isBuildScenarioOpen, setIsBuildScenarioOpen] = useState<boolean>(
    false,
  );
  const [dataForBuildScenario, setDataForBuildScenario] = useState<{
    serviceName: string;
    breakdownType: 'Monthly' | 'Quarterly' | 'Annually';
    unitOfFees: string;
    unitValue: number;
    feeCalculation: FixedCostFeeCalculation;
    totalFee: number;
    scenarioId: string;
    vendorId: string;
    serviceId: string;
    scenarioName: string;
    tableType: TableType;
    type: BuildScenarioRowResult;
  }>({
    serviceName: '',
    breakdownType: 'Annually',
    unitOfFees: '',
    unitValue: 0,
    feeCalculation: {
      source: '',
      details: [],
      detailsType: undefined,
    },
    totalFee: 0,
    scenarioId: '',
    vendorId: '',
    serviceId: '',
    scenarioName: '',
    tableType: 'FIXED',
    type: 'Fees',
  });
  const [dataByType, setDataByType] = useState<any>({
    Monthly: [],
    Quarterly: [],
    Annually: [],
  });
  const [capValues, setCapValues] = useState<{ [key: string]: number | null }>({
    capValue: null,
    flatFee: null,
  });
  const [scenarioFee, setScenarioFee] = useState<number>(0);
  const [fixedCostColumns, setFixedCostColumns] = useState(
    getFixedCostColumns(
      () => {},
      () => {},
    ),
  );
   
  const [variableCostColumns, setVariableCostColumns] = useState(
    getVariableCostColumns(() => {}),
  );
  const [fixedCost, setFixedCost] = useState<FixedCost>(getEmptyFixedCost());
  const [variableCost, setVariableCost] = useState<VariableCost>(
    getEmptyVariableCost(),
  );
   
  const [employeeCount, setEmployeeCount] = useState<EmployeeCountDataType>({
    employeesYearlyAverage: 0,
    membersYearlyAverage: 0,
    employeesBySubscriptionYearlyAverage: [],
    employeesByPlanYearlyAverage: [],
  });

  //Functions
  const handleModalClose = () => {
    setIsOpen(false);
    setScenarioInfo({
      name: '',
    });
  };

  const getScenarioFee = (totalFee: number) => {
    let scenarioFee = 0;

    if (capValues?.flatFee && capValues?.flatFee !== null) {
      scenarioFee = capValues.flatFee;
    } else if (
      capValues?.capValue &&
      capValues?.capValue !== null &&
      capValues?.capValue < dataForBuildScenario?.totalFee
    ) {
      scenarioFee = capValues?.capValue;
    } else {
      scenarioFee = totalFee;
    }
    return scenarioFee;
  };

  const handleSaveScenario = async () => {
    const { totalFixedCost } = calculateContributions(fixedCost, []);
    const { totalVariableCost } = calculateVariableContributions(variableCost);
    const savedScenario = await addScenarios(
      egNid,
      scenarioInfo,
      email,
      selectedDates?.startDate,
      selectedDates?.endDate,
      totalFixedCost,
      totalVariableCost,
      openSnackbar,
    );

    const getScenarioColumn = (scenarioName: string, tableType: TableType) => ({
      name: scenarioName,
      accessor: scenarioName,
      width: '23%',
      cell: (
        value: number,
        row: any,
        rowType: RowType,
        vendor: any,
        col: any,
      ) => (
        <BuildScenario
          handleCurrent={() =>
            handleUseCurrent(value, row, rowType, vendor, col, tableType)
          }
          handleBuildScenario={() =>
            handleClickBuildScenario(
              value,
              row,
              rowType,
              vendor,
              col,
              tableType,
            )
          }
          value={value}
          handleScenario={() =>
            handleClickBuildScenario(
              value,
              row,
              rowType,
              vendor,
              col,
              tableType,
            )
          }
          row={row}
          cellValue={row[scenarioName]}
        />
      ),
    });

    if (savedScenario) {
      await saveBuildScenario(
        egNid,
        savedScenario?._id,
        resetFeesToZero(fixedCost),
        resetVariableCostValuesToZero(variableCost),
        openSnackbar,
      );
      const { scenarioName, notes, _id } = savedScenario;

      setScenarios((prev) => [
        ...prev,
        { name: scenarioName, notes: notes, id: _id },
      ]);
      setSelectedScenarios((prev) => [
        ...prev,
        { id: _id, name: scenarioName, notes: notes },
      ]);

      setFixedCostColumns((prev: any) => {
        return [...prev, getScenarioColumn(scenarioName, 'FIXED')];
      });

      updateScenarioData(_id, scenarioName);

      setVariableCostColumns((prev: any) => {
        return [...prev, getScenarioColumn(scenarioName, 'VARIABLE')];
      });
      handleModalClose();
    }
  };

  const formatRowsToDetails = (updatedData: any[]): Detail[] => {
    return updatedData.map((row: any) => {
      const { contribution, ...rest } = row;

      const values: TimeSeriesEntry[] = Object.entries(rest).map(
        ([dateRange, rawValue]) => {
          const parsedValue =
            typeof rawValue === 'number'
              ? rawValue
              : typeof rawValue === 'string'
              ? Number(rawValue) || null
              : null;

          return {
            dateRange,
            value: parsedValue,
          };
        },
      );

      return {
        type: contribution,
        values,
      };
    });
  };

  const handleDataChange = (
    type: 'Monthly' | 'Quarterly' | 'Annually',
    updatedData: any[],
  ) => {
    if (dataForBuildScenario.unitOfFees === 'One Time') {
      const firstRow = updatedData && updatedData[0];
      const key = Object.keys(firstRow).find((key) => key !== 'contribution');
      setDataForBuildScenario((prev) => ({
        ...prev,
        totalFee: key && firstRow[key],
      }));

      setDataByType((prev: any) => ({
        ...prev,
        [type]: updatedData,
      }));
    } else {
      const updatedDetails = formatRowsToDetails(updatedData);
      const { rows, totalFee } = generateBreakdownData(
        updatedDetails,
        dataForBuildScenario.unitOfFees,
        dataForBuildScenario.unitValue,
        type,
        dataForBuildScenario.tableType,
      );

      setDataForBuildScenario((prev) => ({
        ...prev,
        feeCalculation: { ...prev.feeCalculation, details: updatedDetails },
        totalFee,
      }));

      setDataByType((prev: any) => ({
        ...prev,
        [type]: rows,
      }));
    }
  };

  const updateContributionArray = (
    prevArray: any[],
    row: any,
    col: any,
    vendor: any,
    isFixed: boolean,
  ) => {
    return prevArray?.map((item) => {
      if (item?.vendorID !== vendor?.vendorID) {
        return item;
      }

      if (isFixed) {
        return {
          ...item,
          services: item?.services?.map((service: any) =>
            service?.serviceID === row?.serviceID
              ? {
                  ...service,
                  [col?.name]: {
                    ...service[col?.name],
                    isChosen: true,
                    fees: service?.fees,
                  },
                }
              : service,
          ),
        };
      }

      return {
        ...item,
        [col?.name]: {
          ...item[col?.name],
          isChosen: true,
          value: item?.value,
        },
      };
    });
  };

  const handleUseCurrent = async (
    value: string | number,
    row: any,
    rowType: RowType,
    vendor: any,
    col: any,
    tableType: TableType,
  ) => {
    const isFixedCost = tableType === 'FIXED' ? true : false;
    const totalFee = tableType === 'FIXED' ? row?.fees : row?.value;

    if (isFixedCost) {
      setFixedCost((prev) => {
        return {
          ...prev,
          planContribution: {
            fees:
              rowType === 'primary'
                ? updateContributionArray(
                    prev?.planContribution?.fees,
                    row,
                    col,
                    vendor,
                    true,
                  )
                : prev?.planContribution?.fees,
            stoploss: [],
            credits:
              rowType === 'secondary'
                ? updateContributionArray(
                    prev?.planContribution?.credits,
                    row,
                    col,
                    vendor,
                    true,
                  )
                : prev?.planContribution?.credits,
          },
          memberContribution: updateContributionArray(
            prev?.memberContribution,
            row,
            col,
            vendor,
            true,
          ),
        };
      });
    } else {
      setVariableCost((prev) => {
        return {
          ...prev,
          planContribution: {
            fees:
              rowType === 'primary'
                ? updateContributionArray(
                    prev?.planContribution?.fees,
                    row,
                    col,
                    vendor,
                    false,
                  )
                : prev?.planContribution?.fees,
            rebates:
              rowType === 'secondary'
                ? updateContributionArray(
                    prev?.planContribution?.rebates,
                    row,
                    col,
                    vendor,
                    false,
                  )
                : prev?.planContribution?.rebates,
          },
          memberContribution: updateContributionArray(
            prev?.memberContribution,
            row,
            col,
            vendor,
            false,
          ),
        };
      });
    }

    await updateBuildScenario(
      egNid,
      row[col?.name]?.id,
      vendor?.vendorID,
      row?.serviceID,
      row?.feeCalculation,
      totalFee,
      undefined,
      undefined,
      getRowType(rowType, tableType),
      tableType,
      openSnackbar,
    );
  };

  const generateBreakdownData = (
    breakdownDetails: Detail[],
    unitOfFees: string,
    unitValue: number,
    breakdownType: 'Monthly' | 'Quarterly' | 'Annually',
    tableType?: TableType,
  ) => {
    if (unitOfFees === 'One Time') {
      const startDate = moment(selectedDates?.startDate);
      const endDate = moment(selectedDates?.endDate);

      const startYear = startDate.format('YYYY');
      const endYear = endDate.format('YYYY');
      const key =
        startYear === endYear ? startYear : `${startYear} - ${endYear}`;

      const rows = [
        {
          contribution: unitToRowTitleMap[unitOfFees],
          [key]: unitValue,
        },
      ];

      return {
        type: breakdownType,
        rows,
        totalFee: unitValue,
      };
    }

    if (tableType === 'VARIABLE') {
      const feeValues = breakdownDetails[0].values || [];

      const variableRow = {
        contribution: 'Claims',
        ...feeValues.reduce((acc: any, val: any) => {
          acc[val.dateRange] = val.value;
          return acc;
        }, {}),
      };

      const total = feeValues.reduce(
        (sum, val) => sum + Number(val.value || 0),
        0,
      );

      return {
        type: breakdownType,
        rows: [variableRow],
        totalFee: total,
      };
    }

    const variable = unitToRowTitleMap[unitOfFees];

    const feeValues =
      breakdownDetails?.find((item) => item.type === variable)?.values || [];

    const unitValues =
      breakdownDetails?.find((item) => item.type === unitOfFees)?.values || [];

    // Build unitRow: use unitValues if present, else copy from feeValues
    const unitRow = feeValues.reduce((acc: any, val: any) => {
      const matchingUnit = unitValues.find(
        (u) => u.dateRange === val.dateRange,
      );
      acc[val.dateRange] =
        matchingUnit?.value !== undefined ? matchingUnit.value : unitValue;
      return acc;
    }, {}); // second row

    // Row 1: Variable row
    const variableRow = {
      contribution: variable,
      ...feeValues.reduce((acc: any, val: any) => {
        acc[val.dateRange] = val.value;
        return acc;
      }, {}),
    };

    // Row 2: Unit row
    const unitRowWithLabel = {
      contribution: unitOfFees,
      ...unitRow,
    };

    // Row 3: Fee row
    const feeRow: any = { contribution: 'Fee' };
    let total = 0;

    feeValues.forEach((val: any) => {
      const unit = Number(unitRow[val.dateRange]); // trust merged logic (even if value is 0)
      const calculationVariables = getCalculationVariables(
        unitOfFees as UnitType,
        {
          monthCount: breakdownType === 'Annually' ? 12 : 1,
          yearCount: 1,
        },
        [{ values: [val], type: variable }],
      );
      const updatedFee = calculateFee(
        unitOfFees as UnitType,
        unit,
        calculationVariables,
      );
      feeRow[val.dateRange] = updatedFee;
      total += updatedFee;
    });

    const rows = [variableRow, unitRowWithLabel, feeRow];
    return {
      type: breakdownType,
      rows,
      totalFee: total,
    };
  };

  const handleClickBuildScenario = async (
    value: string | number,
    row: any,
    rowType: RowType,
    vendor: any,
    col: any,
    tableType: TableType,
  ) => {
    setCapValues({
      capValue: null,
      flatFee: null,
    });
    let unitOfFees, nameOfService, feeCalculation, flatFee, capFee, fees;

    if (tableType === 'FIXED') {
      if (row?.[col?.name]?.isChosen) {
        ({
          unitOfFees,
          nameOfService,
          feeCalculation,
          flatFee,
          capFee,
          fees,
        } = row[col?.name]);
      } else {
        ({ unitOfFees, nameOfService, feeCalculation, fees } = row);
      }
    } else if (tableType === 'VARIABLE') {
      if (row?.[col?.name]?.isChosen) {
        ({
          nameOfService,
          flatFee,
          capFee,
          fees,
          unitOfFees,
          feeCalculation,
        } = row[col?.name]);
      } else {
        nameOfService = row?.claims;
        feeCalculation = normalizeFeeCalculation(
          row.feeCalculation,
          row.claims,
        );
        unitOfFees = feeCalculation?.detailsType || 'Monthly';
        fees = row?.value;
      }
    }

    setScenarioFee(fees);

    if (capFee && capFee !== null) {
      setCapValues({ capValue: capFee });
    }
    if (flatFee && flatFee !== null) {
      setCapValues({ flatFee });
    }

    const { rows, type, totalFee } = generateBreakdownData(
      feeCalculation?.details || {},
      unitOfFees,
      unitOfFees === 'One Time' ? fees : row?.value,
      feeCalculation?.detailsType || 'Annually',
      tableType,
    );

    const scenarioFee = getScenarioFee(totalFee);

    setScenarioFee(scenarioFee);

    setDataForBuildScenario({
      serviceName: nameOfService,
      breakdownType: feeCalculation?.detailsType,
      feeCalculation: feeCalculation,
      unitOfFees: unitOfFees,
      unitValue: row?.value,
      totalFee: scenarioFee,
      scenarioId: row[col?.name]?.id ?? '',
      vendorId: vendor?.vendorID ?? '',
      serviceId: row?.serviceID ?? '',
      scenarioName: col?.name || '',
      type: getRowType(rowType, tableType),
      tableType,
    });

    setDataByType((prev: any) => ({
      ...prev,
      [type]: rows,
    }));
    setIsBuildScenarioOpen(true);
  };

   
  const handleSubmitBuildScenario = async () => {
    const {
      vendorId,
      scenarioId,
      serviceId,
      feeCalculation,
      scenarioName,
      type,
      tableType,
    } = dataForBuildScenario;

    if (tableType === 'FIXED') {
      setFixedCost((prev) => {
        const updateServices = (items: any[]) =>
          items?.map((item: any) => {
            if (item.vendorID !== vendorId) {
              return item;
            }

             
            const updatedServices = item?.services?.map((service: any) =>
              service.serviceID === serviceId
                ? {
                    ...service,
                    [scenarioName]: {
                      ...service[scenarioName],
                      fees: scenarioFee,
                      feeCalculation,
                      flatFee: capValues['flatFee'],
                      capFee: capValues['capValue'],
                      isChosen: true,
                    },
                  }
                : service,
            );

            return { ...item, services: updatedServices };
          });

        return {
          ...prev,
          planContribution: {
            fees: updateServices(prev?.planContribution?.fees ?? []),
            credits: updateServices(prev?.planContribution?.credits ?? []),
            stoploss: [],
          },
          memberContribution: updateServices(prev?.memberContribution ?? []),
        };
      });
    } else if (tableType === 'VARIABLE') {
      setVariableCost((prev) => {
        const updateVendors = (items: any[]) =>
          items?.map((item: any) =>
            item.vendorID === vendorId
              ? {
                  ...item,
                  [scenarioName]: {
                    ...item[scenarioName],
                    value: scenarioFee,
                    feeCalculation,
                    flatFee: capValues['flatFee'],
                    capFee: capValues['capValue'],
                    isChosen: true,
                  },
                }
              : item,
          );

        return {
          ...prev,
          planContribution: {
            fees: updateVendors(prev?.planContribution?.fees ?? []),
            rebates: updateVendors(prev?.planContribution?.rebates ?? []),
          },
          memberContribution: updateVendors(prev?.memberContribution ?? []),
        };
      });
    }

    await updateBuildScenario(
      egNid,
      scenarioId,
      vendorId,
      serviceId,
      feeCalculation,
      scenarioFee,
      capValues?.capValue!,
      capValues?.flatFee!,
      type,
      tableType,
      openSnackbar,
    );
    setIsBuildScenarioOpen(false);
  };

  const handleChangeScenario = (scenarioNames: string[]) => {
    const selected = scenarioNames
      .map((name) => scenarios?.find((s) => s.name === name))
      .filter(
        (s): s is { name: string; notes?: string; id: string } =>
          s !== undefined,
      );

    setSelectedScenarios(selected);

    const getScenarioColumn = (item: any, tableType: TableType) => ({
      name: item.name,
      accessor: item.name,
      width: '23%',
      cell: (
        value: number,
        row: any,
        rowType: RowType,
        vendor: any,
        col: any,
      ) => (
        <BuildScenario
          handleCurrent={() =>
            handleUseCurrent(value, row, rowType, vendor, col, tableType)
          }
          handleBuildScenario={() =>
            handleClickBuildScenario(
              value,
              row,
              rowType,
              vendor,
              col,
              tableType,
            )
          }
          value={value}
          handleScenario={() =>
            handleClickBuildScenario(
              value,
              row,
              rowType,
              vendor,
              col,
              tableType,
            )
          }
          row={row}
          cellValue={row[item?.name]}
        />
      ),
    });
    setFixedCostColumns((prev: any) => {
      const defaultCols = prev.filter(
         
        (col: any) => !scenarios.find((s) => s.name === col.name),
      );
      const selectedScenarioColumns = selected.map((item: any) =>
        getScenarioColumn(item, 'FIXED'),
      );

      return [...defaultCols, ...selectedScenarioColumns];
    });

    setVariableCostColumns((prev: any) => {
      const defaultCols = prev.filter(
         
        (col: any) => !scenarios.find((s) => s.name === col.name),
      );
      const selectedScenarioColumns = selected.map((item: any) =>
        getScenarioColumn(item, 'VARIABLE'),
      );
      return [...defaultCols, ...selectedScenarioColumns];
    });
  };

  const updateVendorsWithScenario = (
    prevVendors: any[] = [],
    scenarioVendors: any[] = [],
    scenarioId: string,
    scenarioName: string,
  ) => {
    return prevVendors.map((prevVendor: any) => {
      const matchingVendor = scenarioVendors.find(
        (bVendor: any) => bVendor.vendorID === prevVendor.vendorID,
      );

      if (!matchingVendor) {
        return prevVendor;
      }

      const updatedServices = prevVendor.services?.map((prevService: any) => {
        const matchingService = matchingVendor.services?.find(
           
          (bService: any) => bService.serviceID === prevService.serviceID,
        );

        return matchingService
          ? {
              ...prevService,
              [scenarioName]: {
                ...matchingService,
                id: scenarioId,
              },
            }
          : prevService;
      });

      return {
        ...prevVendor,
        services: updatedServices,
      };
    });
  };

  const updateClaimsWithScenario = (
    prevVendors: any[] = [],
    scenarioVendors: any[] = [],
    scenarioId: string,
    scenarioName: string,
  ) => {
    return prevVendors.map((prevVendor: any) => {
      const matchingVendor = scenarioVendors.find(
        (bVendor: any) => bVendor.vendorID === prevVendor.vendorID,
      );

      if (!matchingVendor) {
        return prevVendor;
      }

      return {
        ...prevVendor,
        [scenarioName]: {
          ...matchingVendor,
          id: scenarioId,
        },
      };
    });
  };

  const updateScenarioData = async (
    scenarioId: string,
    scenarioName: string,
  ) => {
    const buildScenario = await fetchBuildScenario(egNid, scenarioId);
    setFixedCost((prev) => {
      return {
        ...prev,
        planContribution: {
          ...prev.planContribution,
          fees: updateVendorsWithScenario(
            prev?.planContribution?.fees,
            buildScenario?.fixedCost?.planContribution?.fees,
            scenarioId,
            scenarioName,
          ),
          credits: updateVendorsWithScenario(
            prev?.planContribution?.credits,
            buildScenario?.fixedCost?.planContribution?.credits,
            scenarioId,
            scenarioName,
          ),
        },
        memberContribution: updateVendorsWithScenario(
          prev?.memberContribution,
          buildScenario?.fixedCost?.memberContribution,
          scenarioId,
          scenarioName,
        ),
      };
    });
    setVariableCost((prev) => {
      return {
        ...prev,
        planContribution: {
          ...prev.planContribution,
          fees: updateClaimsWithScenario(
            prev?.planContribution?.fees,
            buildScenario?.variableCost?.planContribution?.fees,
            scenarioId,
            scenarioName,
          ),
          rebates: updateClaimsWithScenario(
            prev?.planContribution?.rebates,
            buildScenario?.variableCost?.planContribution?.rebates,
            scenarioId,
            scenarioName,
          ),
        },
        memberContribution: updateClaimsWithScenario(
          prev?.memberContribution,
          buildScenario?.variableCost?.memberContribution,
          scenarioId,
          scenarioName,
        ),
      };
    });
  };

  //Axios Calls
  const getScenarios = async () => {
    const data = await fetchScenarios(
      egNid,
      selectedDates?.startDate,
      selectedDates?.endDate,
    );
    const fetchedScenarios = data?.scenarios || [];

    setScenarios(
      fetchedScenarios.map((item: any) => ({
        id: item?._id,
        name: item?.scenarioName,
        notes: item?.notes,
      })),
    );

    // Define type once for clarity
    type Scenario = {
      id: string;
      name: string;
      notes?: string;
    };

    // Fallback to first scenario
    const defaultScenario = fetchedScenarios[0];
    const { scenarioName, notes, _id } = defaultScenario || {
      scenarioName: '',
      notes: '',
      _id: '',
    };

    // Determine which scenario to use
    let currentScenario: Scenario;

    if (location?.state?.scenarioId) {
      const found = fetchedScenarios.find(
        (item: any) => item?._id === location.state.scenarioId,
      );

      currentScenario = {
        id: location.state.scenarioId,
        name: found?.scenarioName || '',
        notes: found?.notes || '',
      };
    } else {
      currentScenario = {
        id: _id,
        name: scenarioName,
        notes,
      };
    }

    setSelectedScenarios([currentScenario]);

    // Scenario column definition
    const getScenarioColumn = (tableType: TableType) => {
      return {
        name: currentScenario.name,
        accessor: currentScenario.name,
        width: '23%',
        cell: (
          value: number,
          row: any,
          rowType: RowType,
          vendor: any,
          col: any,
        ) => (
          <BuildScenario
            handleCurrent={() =>
              handleUseCurrent(value, row, rowType, vendor, col, tableType)
            }
            handleBuildScenario={() =>
              handleClickBuildScenario(
                value,
                row,
                rowType,
                vendor,
                col,
                tableType,
              )
            }
            value={value}
            handleScenario={() =>
              handleClickBuildScenario(
                value,
                row,
                rowType,
                vendor,
                col,
                tableType,
              )
            }
            row={row}
            cellValue={row[currentScenario.name]}
            tableType={tableType}
          />
        ),
      };
    };

    // Update matrix + column state
    updateScenarioData(currentScenario.id, currentScenario.name);
    setFixedCostColumns((prev: any) => [...prev, getScenarioColumn('FIXED')]);
    setVariableCostColumns((prev: any) => [
      ...prev,
      getScenarioColumn('VARIABLE'),
    ]);
  };

  const getAvailableDates = async () => {
    try {
      const response = await getAvailableDatesAPI(egNid);
      setAvaiableDates(response.data.data);
    } catch (error) {
      openSnackbar('Error Fetching Plan Dates', 'error', 2000);
    }
  };

  const APICalls = async () => {
    selectedDates.startDate !== '' &&
      selectedDates.endDate !== '' &&
      (await Promise.allSettled([
        getFinancialForensicsData(
          egNid,
          selectedDates.startDate,
          selectedDates.endDate,
          employerGroupStore.employerGroupResponseData.max_claim_date,
        ),
      ]).then((responses) => {
        if (responses[0].status === 'fulfilled') {
          const response = responses[0].value.data.data;
          setEmployeeCount(response.employeeCount);
          setFixedCost(response.fixedCost);
          setVariableCost(response.variableCost);
        }
      }));
    await getScenarios();
    setLoading(false);
  };

  //UseEffects
  useEffect(() => {
    APICalls();
  }, [selectedDates.startDate, selectedDates.endDate]);

  useEffect(() => {
    const fee = getScenarioFee(dataForBuildScenario?.totalFee);
    setScenarioFee(fee);
  }, [
    dataByType[dataForBuildScenario?.breakdownType],
    dataForBuildScenario?.totalFee,
    capValues,
  ]);

  useEffect(() => {
    if (!egNid) {
      return;
    }
    getAvailableDates();
  }, [egNid]);

  useEffect(() => {
    selectedScenarios?.forEach((s) => {
      updateScenarioData(s?.id, s?.name);
    });
  }, [selectedScenarios]);

  //Resubale Components
  const getTitleTypography = (label: string) => {
    return (
      <Typography
        fontSize="18px"
        lineHeight="100%"
        textColor={patientAccessTheme.palette.text.highemphasis}
        fontType="semiBold"
      >
        {label}
      </Typography>
    );
  };

  const getSubTextTypography = (label: string) => {
    return (
      <Typography
        fontSize="17px"
        lineHeight="100%"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
        fontType="semiBold"
      >
        {label}
      </Typography>
    );
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Grid>
          <Grid className={classes.header}>
            <PageTitleAndSubTitle
              title={
                <Box className={classes.titleFlex}>
                  {getTitleTypography('Scenario Workspace')}
                  {getSubTextTypography('built on baseline')}
                  <CustomDateSelectionDropdown
                    setSelectedDates={setSelectedDates}
                    availableDates={avaiableDates}
                  />
                </Box>
              }
              subTitle={''}
            />
            <Grid className={classes.titleFlex}>
              <Typography
                fontSize="12px"
                fontType="regular"
                lineHeight="16.8px"
                textColor={patientAccessTheme.palette.text.highemphasis}
                margin={`11px 0px 15px 0px`}
              >
                Scenarios
              </Typography>
              <AutocompleteWithCheckBoxes
                options={scenarios?.map((item) => item?.name)}
                defaultValue={selectedScenarios?.map((item) => item?.name)}
                placeholder={
                  selectedScenarios?.length > 0 ? '' : 'Select Scenarios'
                }
                noOptionsLabel="No Scenarios Found"
                handleChange={function (
                  event: any,
                  value: any,
                   
                  reason: any,
                   
                  details: any,
                ) {
                  handleChangeScenario(value);
                }}
              />
              <Button
                label={
                  <Typography
                    fontSize="12px"
                    lineHeight="100%"
                    textColor={patientAccessTheme.palette.grey[700]}
                    fontType="medium"
                  >
                    + Add Scenario
                  </Typography>
                }
                variant="outlined"
                className={classes.addScenarioButton}
                height="22px"
                width="auto"
                onClick={() => setIsOpen(true)}
              />
            </Grid>
          </Grid>
          <Grid className={classes.divider}></Grid>
          <Grid className={classes.body}>
            <Financials
              fixedCostColumns={fixedCostColumns}
              variableCostColumns={variableCostColumns}
              fixedPrimary={fixedCost?.planContribution?.fees}
              fixedSecondary={fixedCost?.planContribution?.credits}
              fixedMember={fixedCost?.memberContribution ?? []}
              variablePrimary={variableCost?.planContribution?.fees}
              variableSecondary={variableCost?.planContribution?.rebates}
              variableMember={variableCost?.memberContribution ?? []}
              fixedCostTableLoading={false}
              variableCostTableLoading={false}
            />
          </Grid>
          <AddBuildScenarioModal
            open={isOpen}
            handleModalClose={handleModalClose}
            handleConfirm={handleSaveScenario}
            scenarioInfo={scenarioInfo}
            setScenarioInfo={setScenarioInfo}
          />
          {isBuildScenarioOpen && (
            <BuildScenarioModal
              open={isBuildScenarioOpen}
              setOpen={setIsBuildScenarioOpen}
              breakdownType={dataForBuildScenario?.breakdownType}
              tableData={dataByType}
              handleSubmit={handleSubmitBuildScenario}
              onTableDataChange={handleDataChange}
              startDate={selectedDates?.startDate}
              endDate={selectedDates?.endDate}
              scenarioFee={scenarioFee}
              capValues={capValues}
              setCapValues={setCapValues}
              serviceName={dataForBuildScenario.serviceName}
            />
          )}
          <Snackbar
            {...snackbarState}
            vertical={'bottom'}
            horizontal={'right'}
            handleClose={handleCloseSnackBar}
          />
        </Grid>
      )}
    </>
  );
};

export default BuildScenarioWorkspacePage;
